var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showPrompt
    ? _c("div", { staticClass: "ios-prompt" }, [
        _c("img", { attrs: { src: _vm.pwaLogo, width: "35", height: "35" } }),
        _vm.isSafari
          ? _c("p", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("front.pwa.install_message"))
              }
            })
          : _c("p", {
              domProps: { innerHTML: _vm._s(_vm.$t("front.pwa.ios_message")) }
            }),
        _c("span", [_vm._v("×")])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }